import type { ArApAgingDTO, ArApAgingCardDTO } from "../models/arApAgingDto";
import type {
  ArApAgingCardEntity,
  ArApAgingEntity,
} from "../../domain/entities/ArApAgingEntity";

function mapCard(dto?: ArApAgingCardDTO | null): ArApAgingCardEntity {
  return {
    totalOutstandingAmount: dto?.totalOutstandingAmount ?? 0,
    overdueAmount: dto?.overdueAmount ?? 0,
    notOverdueAmount: dto?.notOverdueAmount ?? 0,
    currencySymbol: dto?.currencySymbol ?? "₹",
    buckets: (dto?.buckets ?? []).map((bucket) => ({
      label: bucket.label,
      amount: bucket.amount,
      percent: bucket.percent,
    })),
    alertMessage: dto?.alertMessage ?? null,
    topOutstanding: (dto?.topOutstanding ?? []).map((item) => ({
      name: item.name,
      bucketLabel: item.bucketLabel,
      amount: item.amount,
    })),
    othersOutstanding: {
      count: dto?.othersOutstanding?.count ?? 0,
      amount: dto?.othersOutstanding?.amount ?? 0,
    },
  };
}

export function arApAgingDtoToEntity(dto: ArApAgingDTO): ArApAgingEntity {
  return {
    receivables: mapCard(dto?.receivables),
    payables: mapCard(dto?.payables),
  };
}
